<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="'Export Csv'">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <div class="row">

    <div class="form-group col-md-4">
      <!-- <img *ngIf="true" [src]="csv" height="35" width="35" alt="">&nbsp; -->
      <label for="csvInput" class="letrasDanger">ArchivoCSV.csv*</label>
      <input type="file" class="form-control-file" id="csvInput" (change)="onFileSelect($event)" #fileInput />
      <!-- accept=".csv" -->
    </div>
  </div>
  <br>
  <br>
</ng-template>

<div class="row">
  <div class="form-group col-md-12">
    <button (click)="procesar()" class="btn btn-success btn-block btn-lg">Procesar</button>
  </div>
</div>